import LoaderStyles from './Loader.module.scss';

const Loader = () => {
  return (
    <div className={LoaderStyles.loader}>
      <svg width="80" height="80" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" strokeLinecap="round">
          <g>
            <path
              stroke="black"
              strokeWidth="6"
              d="M 30 12
           A 38 38 0 0 1 88 50"
            />
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 50 50"
              to="360 50 50"
              dur="1.2s"
              repeatCount="indefinite"
            />
          </g>

          <g>
            <path
              stroke="grey"
              strokeWidth="6"
              d="M 38 22
           A 28 28 0 0 1 78 50"
            />
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="360 50 50"
              to="0 50 50"
              dur="1.2s"
              repeatCount="indefinite"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Loader;
